import { render, staticRenderFns } from "./ManageCompetitor.vue?vue&type=template&id=24eb46ff&scoped=true&"
import script from "./ManageCompetitor.vue?vue&type=script&lang=js&"
export * from "./ManageCompetitor.vue?vue&type=script&lang=js&"
import style0 from "./ManageCompetitor.vue?vue&type=style&index=0&id=24eb46ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb46ff",
  null
  
)

export default component.exports